<script lang="ts">
	import { offset, flip, shift, type Placement } from 'svelte-floating-ui/dom';
	import { createFloatingActions } from 'svelte-floating-ui';
	import { debounce } from '$lib/utils/debounce';

	export let classes = '';
	export let placement: Placement = 'bottom';
	export let blockedTooltip = false;

	const [floatingRef, floatingContent] = createFloatingActions({
		placement: placement,
		strategy: 'fixed',
		middleware: [offset(4), flip(), shift()]
	});

	const updateDisplay = debounce((val: boolean) => {
		showTooltip = val;
	}, 50);

	function updateDisplayWrap(val: boolean) {
		return () => updateDisplay(val);
	}
	export let showTooltip = false;
</script>

<div
	use:floatingRef
	on:focus={updateDisplayWrap(true)}
	on:mouseenter={updateDisplayWrap(true)}
	on:blur={updateDisplayWrap(false)}
	on:mouseleave={updateDisplayWrap(false)}
	role="tooltip"
	class={classes}
>
	<slot name="trigger">
		<span class="missing">trigger</span>
	</slot>
</div>
{#if showTooltip && !blockedTooltip}
	<div
		role="tooltip"
		id="tooltip"
		class="z-40"
		use:floatingContent
		on:focus={updateDisplayWrap(true)}
		on:mouseenter={updateDisplayWrap(true)}
		on:blur={updateDisplayWrap(false)}
		on:mouseleave={updateDisplayWrap(false)}
	>
		<slot name="dd">
			<span class="missing">tooltip</span>
		</slot>
	</div>
{/if}
